<kendo-grid #grid="remoteBindingDirectiveRef"
            appCrossSiteUserNotificationsRemoteBinding
            [height]="600"
            [pageSize]="this.PageSize"
            [skip]="this.Skip"
            [sort]="this.Sort"
            scrollable="virtual"
            [rowClass]="Helper.applyClickedRowClassToClickedRow"
            (cellClick)="Helper.setIndexOfClickedRow($event)"
            [(filter)]="Helper.Filter"
            [rowHeight]="20"
            [sortable]="SortSettings"
            [resizable]="true"
            [filterable]="true">

    <kendo-grid-command-column [width]="80" class="!k-text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="command-column-buttons">
                <button class="button" kendoButton kendoGridFocusable (click)="openForm(dataItem)" title="Open Form">Open</button>
                <mat-icon class="command-btn material-icons-outlined" kendoButton (click)="toggleSubscribed(dataItem)" title="Toggle Subscribed">{{SubscribedIcon(dataItem)}}</mat-icon>
            </div>
        </ng-template>
    </kendo-grid-command-column>

    @for (columnDef of this.ColumnDefs; track columnDef; let iColIndex = $index) {
    <kendo-grid-column [field]="columnDef.fieldName"
                       [title]="columnDef.title"
                       [filterable]="true">
    </kendo-grid-column>
    }

</kendo-grid>
